import React from "react"
import PropTypes from "prop-types"


import LoaderSection from '../app_components/LoaderSection'
import DashMoreToDoSection from './DashMoreToDo'
import ProfileBadgeSection from '../gamification_components/ProfileBadgeSection'
import UpcomingMeetingSection from '../profile_sections/UpcomingMeetingSection'
import NotificationSection from './NotificationSection'
import UserGamificationDashboard from './UserGamificationDashboard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'


class MemberDashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentUser: [],
      notifications: [],
      dataLoaded: false,
      lexes: 0,
      width: 0,
      accountUnpaused: false,
      blogPosts: []
    }
    this.renderUnpauseAccount = this.renderUnpauseAccount.bind(this)
    this.unpauseAccount = this.unpauseAccount.bind(this)
  }

  updateDimensions() {
    this.setState({
      width: window.innerWidth
    })
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillMount() {
    $.ajax({
      url: `../getUserData`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          currentUser: JSON.parse(data.data.current_user),
          notifications: JSON.parse(data.data.notifications),
          dataLoaded: true,
          lexes: data.data.lexes,
          languages: JSON.parse(data.data.learning_languages),
          blogPosts: JSON.parse(data.data.blog_posts)
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  unpauseAccount() {
    this.setState({
      accountUnpaused: true
    })
    let data = {
      user: {
        status: 'Active'
      }
    }
    $.ajax({
      url: `../updateUser`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {

      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    })
  }

  renderUnpauseAccount() {
    if(this.state.accountUnpaused) {
      return(
        <div
          style={{padding: 10}}>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <h3 className="lightBlue bold">I’m back and stronger than ever!</h3>
          </div>
          <h4 className="lightGrey" style={{marginTop: 15}}>Ready to rock n’ roll? You’re account is fully active again!</h4>
        </div>
      )
    }
    return(
      <div
        onClick={() => this.unpauseAccount()}
        className="clickable"
        style={{padding: 10}}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
          <h3 className="red bold">Reactivate account</h3>
          <FontAwesomeIcon
            icon={faArrowRight}
            className="red"
            style={{fontSize: 16, marginRight: 10}}
          />
        </div>
        <h4 className="lightGrey" style={{marginTop: 15}}>Your account is currently ‘taking a break’. People are not matching with you, and you aren’t receiving updates. Ready to dive back in? Just click me ! (Don’t worry - you can take a break again at any time!)</h4>
      </div>
    )
  }
  //<WeeklyWritingPrompt lexicoin={this.props.lexicoin}/>


  render() {
    if(this.state.dataLoaded) {
      return(
        <div style={{margin: 'auto', maxWidth: 600}}>
              <div className="userGamificationDashboard">
                {this.state.currentUser.status === "Travelling" &&
                <div style={{marginTop: 15}}>
                  {this.renderUnpauseAccount()}
                  <div className="greyDivider" />
                </div>
                }
                <UserGamificationDashboard
                  currentUser={this.state.currentUser}
                  lexicoin={this.props.lexicoin}
                  connectCoin={this.props.connectCoin}
                  lexes={this.state.lexes}
                  missingImg={this.props.missingImg}
                />
              </div>
              <div className="notificationSection">
                <NotificationSection
                  confettiLottie={this.props.confettiLottie}
                  lexicoin={this.props.lexicoin}
                  closeIcon={this.props.closeIcon}
                  />
              </div>
              <div className="upcomingMeetingSection">
                <UpcomingMeetingSection
                  image_loader={this.props.image_loader}
                  missingImg={this.props.missingImg}
                  currentUser={this.state.currentUser}
                  />
              </div>
              <div className="profileBadgeSection">
                <ProfileBadgeSection
                  userId={this.state.currentUser.id}
        				  dashboard={true}
        				  closeIcon={this.props.closeIcon}
                  width={this.state.width}
        				  image_loader={this.props.image_loader} />
              </div>
              <DashMoreToDoSection
                width={this.state.width}
                languages={this.state.languages}
                readingIcon={this.props.readingIcon}
                writingIcon={this.props.writingIcon}
                blogPosts={this.state.blogPosts}
              />

        </div>
      )
    }
    return <LoaderSection/>
  }
}

export default MemberDashboard;
